import CopilotMessagesAPI from 'dashboard/api/captain/copilotMessages';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'CopilotMessages',
  API: CopilotMessagesAPI,
  getters: {
    getMessagesByThreadId: state => copilotThreadId => {
      return state.records
        .filter(record => record.copilot_thread?.id === Number(copilotThreadId))
        .sort((a, b) => a.id - b.id);
    },
  },
  actions: mutationTypes => ({
    upsert({ commit }, data) {
      commit(mutationTypes.UPSERT, data);
    },
    async fetchByThread({ commit }, threadId) {
      try {
        const { data } = await CopilotMessagesAPI.get(threadId);
        const records = data.payload || data;
        if (Array.isArray(records)) {
          records.forEach(record => commit(mutationTypes.UPSERT, record));
        }
      } catch {
        // Thread may have been deleted — ignore
      }
    },
  }),
});
